import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormHelperText,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-hot-toast";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { useHistory } from "react-router-dom";
import Apiconfigs from "src/ApiConfig/ApiConfig";
import axios from "axios";
import ButtonCircularProgress from "src/component/ButtonCircularProgress";
import { UserContext } from "src/context/User";

const useStyles = makeStyles((theme) => ({
  loginmainBox: {
    height: "100%",
    position: "relative",
    zIndex: 999,
    overflowY: "auto",
    backgroundColor: "#FFFFFF",
    color: "#000",
    "& h2": {
      color: "#000",
      textTransform: "capitalize",
    },
    "& p": {
      fontWeight: 400,
      color: "#000",
    },
    "& .loginBox": {
      height: "initial",
      margin: "15px auto",
      maxWidth: "95%",
      width: "550px",
      maxHeight: "100%",
    },
    "& h6": {
      color: "#000",
      fontWeight: 500,
    },
    "& .forgotText": {
      color: "#F53756",
      fontWeight: 600,
      cursor: "pointer",
    },
    "& .descriptionText": {
      "& p": {
        color: "#000",
      },
      "& span": {
        fontWeight: 600,
        color: "#F53756",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
    },
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  displayColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  displaySpacebetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  displayStart: {
    display: "flex",
    alignItems: "center",
  },
  inputBlack: {
    "& .MuiOutlinedInput-input": {
      color: "#000 !important",
    },
    "& .MuiInputBase-input": {
      color: "#000 !important",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#000 !important",
      opacity: 1,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#00000033",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#00000066",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000",
    },
  },
  loginButton: {
    "&:hover": {
      backgroundColor: "#1d649c !important",
    },
  },
}));

export default function AdminLogin() {
  const classes = useStyles();
  const history = useHistory();
  const auth = useContext(UserContext);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [userType, setUserType] = useState("admin"); // "user" or "admin"

  const formValidationSchema = yup.object().shape({
    email: yup
      .string()
      .trim()
      .email("Please enter valid email address.")
      .required("Email address is required.")
      .max(256, "Should not exceeds 256 characters.")
      .matches("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$"),
    password: yup
      .string()
      .required("Password is required.")
      .max(16, "Password should not exceeds 16 characters.")
      .min(8, "Password must be minimum of 8 characters."),
    // .matches(
    //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
    //   "Please enter a valid password."
    // ),
  });

  const initialValues = {
    email: "",
    password: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: formValidationSchema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const response = await axios({
          method: "POST",
          url: userType === "admin" ? Apiconfigs.adminLogin : Apiconfigs.login,
          data: {
            email: values.email,
            password: values.password,
          },
        });
        console.log("response--=-==", response);
        if (response?.data?.responseCode === 200) {
          toast.success(response.data.responseMessage);
          window.localStorage.setItem("token", response.data.result.token);
          auth.updateProfileHandler();
          auth.setIsLogin(true);

          if (rememberMe) {
            window.localStorage.setItem("rememberedEmail", values.email);
            window.localStorage.setItem("rememberedPassword", values.password);
          } else {
            window.localStorage.removeItem("rememberedEmail");
            window.localStorage.removeItem("rememberedPassword");
          }
          
          // Redirect based on user type
          if (userType === "admin") {
            history.push("/");
          } else {
            history.push("/");
          }
        } else {
          toast.error(response.data.responseMessage);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
        if (error.response) {
          toast.error(error.response.data.responseMessage);
        } else {
          toast.error(error.message);
        }
      }
    },
  });

  useEffect(() => {
    const rememberedEmail = window.localStorage.getItem("rememberedEmail");
    const rememberedPassword =
      window.localStorage.getItem("rememberedPassword");
    if (rememberedEmail && rememberedPassword) {
      formik.setValues({
        email: rememberedEmail,
        password: rememberedPassword,
      });
      setRememberMe(true);
    }
  }, []);

  return (
    <Box className={`${classes.loginmainBox} ${classes.displayCenter}`} >
      <Box className="loginBox" style={{ backgroundColor: '#fff', padding: '20px' }}>
        <Paper className="mainBox" elevation={2} style={{ backgroundColor: '#fff', border: '1px solid #e0e0e0' }}>
          <Box className={classes.displayColumn}>
            <Typography variant="h2" style={{ color: '#000' }}>Welcome Back</Typography>
            <Box className={`${classes.displayCenter} descriptionText`}>
              <Typography variant="body2" mt={1} style={{ color: '#000' }}>
                Login As
                <span
                  onClick={() => history.push("/login")}
                  style={{ cursor: "pointer", color: " #1d649c" }}
                >
                  &nbsp;  User
                </span>
              </Typography>
            </Box>
          </Box>
          <form onSubmit={formik.handleSubmit}>
            <Box mt={2}>
              <Typography mb={1} variant="body2" style={{ color: '#000' }}>
                Email
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter email Id"
                type="email"
                name="email"
                className={classes.inputBlack}
                value={formik.values.email}
                error={formik.touched.email && Boolean(formik.errors.email)}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                autoComplete="nope"
                disabled={isLoading}
              />
              <FormHelperText error>
                {formik.touched.email && formik.errors.email}
              </FormHelperText>
            </Box>
            <Box mt={2}>
              <Typography mb={1} variant="body2" style={{ color: '#000' }}>
                Password
              </Typography>
              <TextField
                placeholder="Enter your password"
                type={showPassword ? "text" : "password"}
                name="password"
                fullWidth
                variant="outlined"
                className={classes.inputBlack}
                value={formik.values.password}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                disabled={isLoading}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: "#000" }}
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        <Box>{showPassword ? <HiEye /> : <HiEyeOff />}</Box>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <FormHelperText error>
                {formik.touched.password && formik.errors.password}
              </FormHelperText>
            </Box>

            <Box className={`${classes.displaySpacebetween}`} my={2}>
              <Box className={classes.displayStart}>
                <Checkbox
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                  disabled={isLoading}
                  style={{ color: "#1e659c" }}
                />
                <Box>
                  <Typography variant="body1" style={{ color: "#1e659c" }}>
                    Remember Me
                  </Typography>
                </Box>
              </Box>
              <Box
                onClick={() => !isLoading && history.push("/forgot-password")}
              >
                <Typography variant="body1" className="forgotText" style={{ color: " #1d649c" }}>
                  Forgot Password?
                </Typography>
              </Box>
            </Box>
            <Box mb={2} className={classes.displayCenter}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                disabled={isLoading}
                className={classes.loginButton}
              >
                Login as {userType === "admin" ? "Admin" : "User"}{isLoading && <ButtonCircularProgress />}
              </Button>
              
            </Box>
            {/* <Box className={classes.displayCenter}> 
              <Typography variant="body2" mt={1}>
                Don't have an account?
                <span
                  onClick={() => history.push("/signup")}
                  style={{ cursor: "pointer", color: " #1d649c" }}
                >
                  &nbsp;Sign Up
                </span>
              </Typography>
            </Box> */}
          </form>
        </Paper>
      </Box>
    </Box>
  );
}
